import * as React from "react";
import ButtonSecondary from "widget/buttonSecondary";
import { connect } from "react-redux";

interface ISendGoodsProps {
  // 订单号
  orderNo: any;
  // 批量发货
  sendGoods: any;
  // 刷新订单
  searchOrder: any;
}

// 批量发货
class SendGoods extends React.Component<ISendGoodsProps, any> {
  constructor(props: ISendGoodsProps) {
    super(props);
  }

  renderText = () => {
    return (
      <div>
        <span>确定为选中的</span>
        <span style={{ color: "red" }}>{this.props.orderNo.length}</span>
        <span>个订单发货吗？</span>
      </div>
    );
  };

  render() {
    return (
      <div className="button-group-child">
        <ButtonSecondary
          buttonText="批量发货"
          modalTitle="批量发货"
          ids={this.props.orderNo}
          modalText={this.renderText()}
          warningText="请选择订单"
          successText="批量发货成功"
          submit={this.props.sendGoods}
          cb={this.props.searchOrder}
        />
      </div>
    );
  }
}

const mapDispatch = dispatch => {
  return {
    sendGoods: dispatch.orderInfo.sendGoods
  };
};

export default connect(
  null,
  mapDispatch
)(SendGoods);
